import script from "./BotaoArrastavel.vue?vue&type=script&setup=true&lang=js"
export * from "./BotaoArrastavel.vue?vue&type=script&setup=true&lang=js"

import "./BotaoArrastavel.vue?vue&type=style&index=0&id=3ac3cc28&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac3cc28"]])

export default __exports__